import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Header from '../../sharedComponent/Header'
import Subheader from '../../sharedComponent/Subheader';
import DoctorSahab from "../../assets/images/DoctorImg.svg";
import Star from "../../assets/images/Star.svg";
import hospital from "../../assets/images/hospital.svg";
import video from "../../assets/images/video.svg";
import borderHeart from "../../assets/images/borderHeart.svg";
import filledHeart from "../../assets/images/filledHeart.svg";
import liteImgArow from "../../assets/images/lightIcon.svg";
import GreenTick from "../../assets/images/greenTick.svg";
import CatImg from "../../assets/images/catImg.svg";
import Reply from "../../assets/images/ReplyIcon.svg";
import ReplyArrow from "../../assets/images/replyArrow.svg";
import CancelTick from "../../assets/images/cancel.svg";
import Nav from 'react-bootstrap/Nav';
import { Tab, Tabs } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';


const DoctorDetails = () => {

    const [heartClicked, setHeartClicked] = useState(false)

    return (
        <>
            <div className="DoctorsDetails" id="cx-main">
                <Subheader />

                {/* Doctor Details Card */}
                <div className="headingCard">
                    <div className="leftContent">
                        <div className="imgHolder">
                            <img src={DoctorSahab} className='imgInside' alt="" />
                        </div>
                        <div className="txtHolder">
                            <p className="headingTxt">Dr. Floyd Miles</p>
                            <p className="timeTxt">Orthopedic | 5 years</p>
                            <p className="rateTxt">
                                <img src={Star} alt="" />
                                4.3 | 100 reviews
                            </p>
                            <div className="imgFlex">
                                <img src={DoctorSahab} alt="" />
                                <img src={DoctorSahab} alt="" />
                                <img src={DoctorSahab} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="rightContent">
                        <p className='hospitalTxt'>
                            <img src={hospital} className='hopsital' alt="" />
                            ₹200 / Visit
                        </p>
                        <p className='videoTxt'>
                            <img src={video} className='video' alt="" />
                            ₹200 / hrs Video Call
                        </p>
                        <p className='videoTxt'>
                            <img onClick={() => setHeartClicked(!heartClicked)} src={heartClicked ? filledHeart : borderHeart} className='borderHeart' alt="" />
                            Mark as favorite
                        </p>
                        <Link to="/BookAppoitment" className="bookBtn">
                            <button>Book Appointment <img src={liteImgArow} alt="" /> </button>
                        </Link>
                    </div>
                </div>

                {/* Content Tabs */}
                <div className="tabsContent">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="Overview">
                        <Nav variant="pills" defaultActiveKey="/home">
                            <Nav.Item>
                                <Nav.Link eventKey="Overview">Overview</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="BusinessHours">Business Hours</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="Locations">Locations</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="RatingsReviews">Ratings & Reviews</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="FAQs">FAQ’s</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="Overview">
                                <div className="overviewCard">
                                    <div className="headerIntro">
                                        <h1 className='headTxt'>About Me</h1>
                                        <p className='insidePara'>Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                            Animi, voluptas aspernatur aliquid inventore nihil quae tempore
                                            officia hic laborum earum sint non excepturi. Perspiciatis esse doloremque
                                            fugiat, quibusdam unde qui atque cum nemo quia! Porro veritatis minima
                                            quasi tempora inventore.earum sint non excepturi. Perspiciatis esse doloremque
                                            fugiat, quibusdam unde qui atque cum nemo quia! Porro veritatis minima
                                            quasi tempora inventore.</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Education</h1>
                                                <ul className='listingValues'>
                                                    <li>Orthopedic & Research</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Languages Known</h1>
                                                <ul className='listingValues'>
                                                    <li>English , Hindi, Marathi</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Registration No.</h1>
                                                <ul className='listingValues'>
                                                    <li>123456789410#12</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-12">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Experience</h1>
                                                <ul className='listingValues'>
                                                    <li>5 years</li>
                                                    <li>100+ Successful Appointments</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Specialization</h1>
                                                <div className="d-flex">
                                                    <ul className='listingValues'>
                                                        <li>Orthopedic & Research</li>
                                                        <li>Orthopedic & Research</li>
                                                    </ul>
                                                    <ul className='listingValues'>
                                                        <li>Orthopedic & Research</li>
                                                        <li>Orthopedic & Research</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="relatedDetails mgBelowNone">
                                                <h1 className="keyTxt">Services</h1>
                                                <div className="d-flex">
                                                    <ul className='listingValues'>
                                                        <li>Orthopedic & Research</li>
                                                        <li>Orthopedic & Research</li>
                                                    </ul>
                                                    <ul className='listingValues'>
                                                        <li>Orthopedic & Research</li>
                                                        <li>Orthopedic & Research</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="BusinessHours">
                                <div className="BusinessHours">
                                    <div className="detailsCard">
                                        <div className="headerDetails">
                                            <div className="date">
                                                <h1 className='dayTxt'>Today</h1>
                                                <label className='dateTxt'>02 July, 2023</label>
                                            </div>
                                            <div className="status">
                                                <h1 className='statusTxt'>
                                                    <img src={GreenTick} alt="" />
                                                    Open Now
                                                </h1>
                                                <label className='dateTxt'>07:00 AM to 09:00 PM</label>
                                            </div>
                                        </div>
                                        <div className="contentTxt">
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Monday, 02 July, 2023</label>
                                                <label htmlFor="" className='insideValue'>07:00 AM to 09:00 PM</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Tuesday, 03 July, 2023</label>
                                                <label htmlFor="" className='insideValue'>07:00 AM to 09:00 PM</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Wednesday, 04 July, 2023</label>
                                                <label htmlFor="" className='insideValue text-danger'><img src={CancelTick} alt="" /> Closed / Holiday</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Thursday, 05 July, 2023</label>
                                                <label htmlFor="" className='insideValue'>07:00 AM to 09:00 PM</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Friday, 06 July, 2023</label>
                                                <label htmlFor="" className='insideValue'>07:00 AM to 09:00 PM</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Saturday, 07 July, 2023</label>
                                                <label htmlFor="" className='insideValue'>07:00 AM to 09:00 PM</label>
                                            </div>
                                            <div className="timingStatusSignals">
                                                <label htmlFor="" className='insideKey'>Sunday, 08 July, 2023</label>
                                                <label htmlFor="" className='insideValue text-danger'><img src={CancelTick} alt="" /> Closed / Holiday</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Locations">
                                <div className="LocationsTab">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="headingTxtNrate">
                                                <label htmlFor="" className='headTxt'>Vet & Pet Clinics</label>
                                                <label htmlFor="" className='reviewTxt'><img src={Star} className='starImg' alt="" /> 4.3 | reviews </label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Clinic Name</h1>
                                                <label htmlFor="" className='TabValues'>David’s Animal Care</label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Facilities</h1>
                                                <ul className='listingValues'>
                                                    <li>OPD</li>
                                                    <li>Surgery</li>
                                                    <li>24 x 7 Oxygen</li>
                                                    <li>Free Wifi</li>
                                                    <li>Ambulance Support</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Clinic Name</h1>
                                                <label htmlFor="" className='TabValues'>125/2, Kalas Road, Vishrantwadi, Pune - 411041.
                                                    Maharashtra, India</label>
                                                <Link to="#" className='directionsLink'>
                                                    <label htmlFor="">Get Directions</label>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Photos</h1>
                                                <div className="photosGallery">
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="headingTxtNrate">
                                                <label htmlFor="" className='headTxt'>Vet & Pet Clinics</label>
                                                <label htmlFor="" className='reviewTxt'><img src={Star} className='starImg' alt="" /> 4.3 | reviews </label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Clinic Name</h1>
                                                <label htmlFor="" className='TabValues'>David’s Animal Care</label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Facilities</h1>
                                                <ul className='listingValues'>
                                                    <li>OPD</li>
                                                    <li>Surgery</li>
                                                    <li>24 x 7 Oxygen</li>
                                                    <li>Free Wifi</li>
                                                    <li>Ambulance Support</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Clinic Name</h1>
                                                <label htmlFor="" className='TabValues'>125/2, Kalas Road, Vishrantwadi, Pune - 411041.
                                                    Maharashtra, India</label>
                                                <Link to="#" className='directionsLink'>
                                                    <label htmlFor="">Get Directions</label>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="relatedDetails">
                                                <h1 className="keyTxt">Photos</h1>
                                                <div className="photosGallery">
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                    <img src={DoctorSahab} className='clinicImgs' alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="RatingsReviews">
                                <div className="RatingsReviews">
                                    <div className="row g-0 reviewRow">
                                        <div className="col-md-1 p-0 reviewCol1">
                                            <div className="catImg">
                                                <img src={CatImg} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-11 p-0 reviewCol11">
                                            <div className="reviewsNchats">
                                                <div className="headingDeta">
                                                    <div className="docName">
                                                        <h1 className='headTxt'>Regular health check up.</h1>
                                                        <label className='labDEt'>Dr. Rohit Sharma</label>
                                                    </div>
                                                    <div className="rates">
                                                        <label className='starNreview'>
                                                            <img src={Star} className='starImg' alt="" />
                                                            4.3
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="chatsNtxt">
                                                    <p className='innerPara'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe, vero doloremque deleniti obcaecati
                                                        cum totam assumenda quaerat, doloribus minus quidem minima incidunt architecto esse aliquid magnam
                                                        culpa labore. Expedita assumenda blanditiis dolor enim iure voluptatibus placeat quos adipisci!</p>
                                                    <label htmlFor="" className='ReplyTxt'><img src={Reply} className='Reply' alt="" /> Reply </label>
                                                    <div className="mainTxtArea">
                                                        <Form.Control
                                                            as="textarea"
                                                            placeholder="Type your comments..."
                                                            style={{ height: '60px' }}
                                                        />
                                                    </div>
                                                    <div className="belowBtns">
                                                        <Link className='cancelLink' to="#">
                                                            <button className='cancleBtn'>Cancel</button>
                                                        </Link>
                                                        <Link className='replyLink' to="#">
                                                            <button className='replyBtn'>Reply <img src={ReplyArrow} className='replyArrow' alt="" /> </button>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-1 p-0">
                                            <div className="catImg">
                                                <img src={CatImg} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-11 p-0 reviewCol11">
                                            <div className="reviewsNchats">
                                                <div className="headingDeta">
                                                    <div className="docName">
                                                        <h1 className='headTxt'>Regular health check up.</h1>
                                                        <label className='labDEt'>Dr. Rohit Sharma</label>
                                                    </div>
                                                    <div className="rates">
                                                        <label className='starNreview'>
                                                            <img src={Star} className='starImg' alt="" />
                                                            4.3
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="chatsNtxt">
                                                    <p className='innerPara'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe, vero doloremque deleniti obcaecati
                                                        cum totam assumenda quaerat, doloribus minus quidem minima incidunt architecto esse aliquid magnam
                                                        culpa labore. Expedita assumenda blanditiis dolor enim iure voluptatibus placeat quos adipisci!</p>
                                                </div>
                                                <div className="doctorReview">
                                                    <div className="imgWrapper">
                                                        <img src={DoctorSahab} className='imsideDoc' alt="" />
                                                    </div>
                                                    <div className="textWrapper">
                                                        <h1 className='description'>Regular health check up.</h1>
                                                        <label className='NameDOc'>Dr. Rohit Sharma</label>
                                                        <p className='ineerPara'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo amet dolore id nam laboriosam cupiditate odit ea est, rerum itaque nulla praesentium repellat pariatur eum repellendus consequatur quia inventore incidunt beatae. Obcaecati at, error nisi facilis rem odit voluptatum incidunt.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="showMoreCol">
                                                <button className='showMoreBtn'>Show All Feedbacks (100)</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="FAQs">
                                <div className="FAQs">
                                    <div className="accordiansTab">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Q. What is the best medicine to treat dog hairs ?</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="solutionFlex">
                                                        <label htmlFor="">Answer: </label>
                                                        <label htmlFor="" className='mx-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna aliqua
                                                            incididunt ut labore et dolore magna aliqua
                                                            Ut enim ad minim veniam, </label>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>Q. What is the best medicine to treat dog hairs ?</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="solutionFlex">
                                                        <label htmlFor="">Answer: </label>
                                                        <label htmlFor="" className='mx-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna aliqua
                                                            incididunt ut labore et dolore magna aliqua
                                                            Ut enim ad minim veniam, </label>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>Q. What is the best medicine to treat dog hairs ?</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="solutionFlex">
                                                        <label htmlFor="">Answer: </label>
                                                        <label htmlFor="" className='mx-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna aliqua
                                                            incididunt ut labore et dolore magna aliqua
                                                            Ut enim ad minim veniam, </label>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>Q. What is the best medicine to treat dog hairs ?</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="solutionFlex">
                                                        <label htmlFor="">Answer: </label>
                                                        <label htmlFor="" className='mx-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna aliqua
                                                            incididunt ut labore et dolore magna aliqua
                                                            Ut enim ad minim veniam, </label>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header>Q. What is the best medicine to treat dog hairs ?</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="solutionFlex">
                                                        <label htmlFor="">Answer: </label>
                                                        <label htmlFor="" className='mx-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna aliqua
                                                            incididunt ut labore et dolore magna aliqua
                                                            Ut enim ad minim veniam, </label>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>
        </>
    )
}

export default DoctorDetails
